import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M16 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M6 12v-2a6 6 0 1 1 12 0v2","key":"svg-2"}],["path",{"d":"M15 9l3 3l3 -3","key":"svg-3"}]]

const IconStatusChange = createReactComponent('outline', 'status-change', 'StatusChange', __iconNode);

export default IconStatusChange;